import {CONSTANTS} from '@apps-common/ui-theme';
import {createPlanetTheme} from '@apps-common/ui-theme/Themes.js';
import MuiGlobalStyles from '@mui/material/GlobalStyles';
import {alpha, lighten} from '@mui/material/styles';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import {createElement} from 'react';

export const theme = createPlanetTheme({
  colorScheme: CONSTANTS.THEME_VARIANTS.LIGHT,
  extendedConfig: {
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: 'none',
            ':hover': {
              textDecoration: 'none',
            },
          },
        },
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  },
});

export const GlobalStyles = () =>
  createElement(MuiGlobalStyles, {
    styles: {
      '.ol-control': {
        display: 'none',
      },
    },
  });

export const defaultFeatureStyle = new Style({
  image: new Circle({
    radius: 7,
    fill: new Fill({
      color: alpha(theme.palette.background.paper, 0.75),
    }),
    stroke: new Stroke({
      color: theme.palette.primary.main,
      width: 2,
    }),
  }),
});

export const highlightFeatureStyle = new Style({
  image: new Circle({
    radius: 9,
    fill: new Fill({
      color: lighten(theme.palette.primary.main, 0.75),
    }),
    stroke: new Stroke({
      color: theme.palette.primary.main,
      width: 2,
    }),
  }),
  zIndex: Infinity,
});
